<div
    *ngrxLet="command() as currentCommand"
    class="st-duration-command-dialog__body">
    <st-duration-seconds-input-field
        [placeholder]="ProductionCommandsPlaceholderLabels[currentCommand.commandType]"
        [value]="currentCommand[ProductionFieldName.DURATION]"
        (onEnter)="onEnterSaveCommand($event)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.DURATION)" />
</div>
